module.exports = __webpack_public_path__ + "static/media/king_diamond.1290b670.png";